import moment from "moment";
import PlayerPaths from "../constants/paths/playerPaths";
import ambifi from "../ambifi";

function getUtcTimestamp() {
	// ISO 8601
	return moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
}

function pushHistoryItem(tree, historyItem, srcObject) {
	tree.push(PlayerPaths.ACTIVITY_HISTORY, historyItem);
	ambifi.persistenceManager.trackHistory(historyItem, srcObject);
}

class History {
	openActivity(tree, identityId, activity) {
		let historyItem = {
			identityId,
			type: "activity",
			action: "open",
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, activity);
	}

	checkSection(tree, path, identityId, section) {
		let historyItem = {
			identityId,
			type: "section",
			action: "check",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, section);
	}

	clearList(tree, path, identityId, list) {
		let historyItem = {
			identityId,
			type: "list",
			action: "reset",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, list);
	}

	clearSection(tree, path, identityId, section) {
		let historyItem = {
			identityId,
			type: "section",
			action: "reset",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, section);
	}

	checkItem(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "check",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	uncheckItem(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "uncheck",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	skipItem(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "skip",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setNotes(tree, path, notes, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setNotes",
			path: path,
			note: notes,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setTextInput(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setTextInput",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setDate(tree, path, value, valueUtc, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setDate",
			path: path,
			value: value,
			valueUtc: valueUtc,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setPicker(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setPicker",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setYesNo(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setYesNo",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setBarcode(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setBarcode",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	clearBarcode(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "clearBarcode",
			path: path,
			value: "",
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setMediaAttachment(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setMediaAttachment",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	resetItemsInRange(tree, path, identityId, activity) {
		let historyItem = {
			identityId,
			type: "activity", //should this be activity level or just an item?
			action: "resetItemsInRange",
			path: path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, activity);
	}

	clearMediaAttachment(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "clearMediaAttachment",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setImagePicker(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setImagePicker",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setSketchPad(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setSketchPad",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	clearSketchPad(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "clearSketchPad",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setLocation(tree, path, value, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setLocation",
			path: path,
			value: value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}
}

export default new History();